// Inline accordion for header-drawer-redesign.liquid. Native <details> already handles
// open/close on click; this only stops that click from reaching MenuDrawer's own summary
// handler in assets/global.js, which otherwise treats every submenu as a sliding full-screen
// panel (menu-opening class + focus trap). Capture-phase stopPropagation on the ancestor
// keeps global.js untouched — remove this file and the <script> tag in
// header-drawer-redesign.liquid to roll back.
document.addEventListener(
  'click',
  (event) => {
    if (event.target.closest('.menu-drawer__accordion-toggle')) {
      event.stopPropagation();
    }
  },
  true
);
